const LengthValidator = (min = null, max = null, message = null) => {
    return (val) => {
        if (val === null || val === undefined) {
            return [true, null];
        }

        const value = String(val);
        const length = Array.from(value).length;

        if (min !== null && length < min) {
            return [
                false,
                message ?? `The value entered must be at least ${min} characters.`,
            ];
        }

        if (max !== null && length > max) {
            return [
                false,
                message ?? `The value entered must be at most ${max} characters.`,
            ];
        }

        return [true, null];
    };
};

export default LengthValidator;
